import {JsonProperty} from '@hyperloris/tyson';

import {DateTime} from 'luxon';
import {Trader} from "./trader";


export class Customer {
  id: number = -1;

  ownerId: number;

  owner: string | undefined;

  code: string | undefined;

  name: string | undefined;

  address: string | undefined;

  zipCode: string | undefined;

  town: string | undefined;

  country: string | undefined;

  desk: string | undefined;

  salesMan: string | undefined;

  email: string | undefined;

  language: string | undefined;

  currency: string | undefined;

  enabled: boolean = true;

  confirmationSendingHour: number;

  modificationDate: DateTime = DateTime.now();

  source: string | undefined;

  capacity: Customer.Capacity = Customer.Capacity.PRINCIPAL;

  invoiceMail: string | undefined;

  outstandingDebt: number = 0;

  bankAccountId: number = 0;

  billingDueNbDays: number = 0;

  moneyOwner: string | undefined;

  vat: boolean | undefined;

  vatNumber: string | undefined;

  lei: string | undefined;

  brokerageTableName: string | undefined;

  confirmationLayout: string | undefined;

  stateAddress: string | undefined;

  invoiceTemplate: string | undefined;

  traders: Trader[];
}

export module Customer {
  export enum Capacity {
    AGENCY = 'AGENCY',
    PRINCIPAL = 'PRINCIPAL',
    MARKETMAKER = 'MARKETMAKER'
  }
}
